import $axios from "../../api";

const state = () => ({
  link: "",
  loading: false,
  errors: null,
});

const mutations = {
  ASSIGN_LINK(state, payload) {
    state.link = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
};

const actions = {
  generateLink({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERRORS", null);
    
    return new Promise((resolve, reject) => {
        $axios
            .post("/website/generate-image-link", payload, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                commit("ASSIGN_LINK", response.data.data);
								resolve();
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    commit("SET_ERRORS", error.response.data);
                }
								reject(error);
            })
            .finally(() => {
                commit("SET_LOADING", false);
            });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};